import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";

import classname from "../../../foundation/utils/classname";
import { IMAGE_MIME_TYPES } from "../../../foundation/utils/file";
import IconImage from "../Icons/IconImage";

import styles from "./AttachImageButton.module.css";

interface Props {
    open?: boolean;
    disabled: boolean;
    onChange: (ev: Event) => void;
}

export default function AttachImageButton({
    disabled = false,
    open = false,
    onChange
}: Props) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (open) {
            inputRef.current?.click();
        }
    }, [open]);

    function resetValue() {
        inputRef.current!.value = "";
    }

    return (
        <label class={classname(styles.attachImageButton, "noSelect", {
            [styles.disabled]: disabled
        })}>
            <input
                ref={inputRef}
                disabled={disabled}
                type="file"
                accept={IMAGE_MIME_TYPES.join(",")}
                onClick={resetValue}
                onChange={onChange}/>
            <IconImage/>
        </label>
    );
}
